import * as React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import * as _ from 'lodash';
import { Config } from '../../helper';
import { getFieldValue, safeHref } from './helper';
import { Links, ResearchFocusGroup, buildLinks, buildExtraFields } from './profile-teaser';

export default function ProfileTeaserSearchResult(props) {
  const {displayOptions} = props;
  const {mapping = {}} = displayOptions;

  return (
    <WithSearch mapContextToProps={({results, wasSearched}) => ({results, wasSearched})}>
      {({results, wasSearched}) => {
        if (!wasSearched) return null;

        if (results.length === 0) {
          return <p className='h--smaller mb-4'>{Config.I18n.Hits.NoResults}</p>;
        }

        return (
          <div className='search-results search-results--profile-teaser'>
            {results.map(r => {
              const fieldValue = (fieldName, defaultValue) => {
                return getFieldValue(r, mapping, fieldName, defaultValue) || defaultValue;
              };

              const rawId = _.get(r, 'id.raw', '');
              const index = _.get(r, '_meta.rawHit._index', '');
              const itemId = `os-profile-teaser-${index}-${rawId}`;
              const image = fieldValue(Config.Mapping.ProfileTeaser.ImageURL, '');
              const title = fieldValue(Config.Mapping.ProfileTeaser.Title, '');
              const jobRole = fieldValue(Config.Mapping.ProfileTeaser.JobRole, '');
              const location = fieldValue(Config.Mapping.ProfileTeaser.Location, '');
              const specialization = fieldValue(Config.Mapping.ProfileTeaser.Specialization, []);
              const institutionName = fieldValue(Config.Mapping.ProfileTeaser.InstitutionName, '');
              const links = buildLinks(r, mapping);
              const extraFields = buildExtraFields(r, mapping);
              const profileHref = safeHref(fieldValue(Config.Mapping.ProfileTeaser.ProfilePageURL, ''));

              return (
                <div key={itemId} className='profile-teaser'>
                  <div className='profile-teaser__content'>
                    <div className='profile-teaser__image'>
                      {image && <img src={image} alt={title}/>}
                    </div>
                    <div className='profile-teaser__links'>
                      <Links links={links}/>
                    </div>
                    <div className='profile-teaser__fields'>
                      <div className='fields-groups'>
                        <div className='fields-group'>
                          <h3 className='h--smallest field field--title'>{title}</h3>
                          {location && <div className='field field--location'>{location}</div>}
                          {jobRole && <div className='field field--job-role'>{jobRole}</div>}
                        </div>

                        {extraFields.length > 0 && (
                          <div className='fields-group'>
                            {extraFields.map(({key, label, value}) => (
                              <React.Fragment key={key}>
                                <div className='field field--heading text-bold'>{label}</div>
                                <div className='field'>{value}</div>
                              </React.Fragment>
                            ))}
                          </div>
                        )}

                        <ResearchFocusGroup specialization={specialization} institutionName={institutionName}/>
                      </div>
                      {profileHref && (
                        <a href={profileHref} className='nv-cta-secondary nv-cta-secondary--small'>
                          {Config.I18n.ProfileTeaser.ProfilePage}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      }}
    </WithSearch>
  );
}
